import apiClient from './apiClient';

// API wrapper functions for document endpoints

export const documentsApi = {
  // Upload additional documents to existing bunkering event
  async uploadDocument(bunkeringId, documentFile, docType) {
    const formData = new FormData();
    formData.append('document_file', documentFile);
    formData.append('doc_type', docType); // 'PoS', 'PoC', or 'ANNEX'

    return apiClient.post(`/documents/bunkerings/${bunkeringId}/documents`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // Get all documents for a bunkering event
  async getBunkeringDocuments(bunkeringId) {
    return apiClient.get(`/documents/bunkerings/${bunkeringId}/documents`);
  },

  // Get specific document metadata
  async getDocument(documentId) {
    return apiClient.get(`/documents/${documentId}`);
  },

  // Download document PDF
  async downloadDocument(documentId) {
    return apiClient.get(`/documents/${documentId}/pdf`, {
      responseType: 'blob', // Important for file downloads
    });
  },

  // Get blockchain status for document
  async getDocumentStatus(documentId) {
    return apiClient.get(`/documents/${documentId}/status`);
  },

  // Resubmit document to blockchain
  async resubmitDocument(documentId) {
    return apiClient.post(`/documents/${documentId}/resubmit`);
  }
};

// Document type constants for frontend use
export const DOCUMENT_TYPES = {
  BDN: 'BDN',
  PoS: 'PoS',
  PoC: 'PoC',
  ANNEX: 'ANNEX'
};

// Document type labels for UI display
export const DOCUMENT_TYPE_LABELS = {
  [DOCUMENT_TYPES.BDN]: 'Bunker Delivery Note',
  [DOCUMENT_TYPES.PoS]: 'Proof of Sustainability',
  [DOCUMENT_TYPES.PoC]: 'Proof of Compliance',
  [DOCUMENT_TYPES.ANNEX]: 'Regulatory Annex'
};

// Blockchain status constants
export const BLOCKCHAIN_STATUS = {
  QUEUED: 'Queued',
  NOT_BUNDLED: 'Not Bundled',
  UNCONFIRMED: 'Unconfirmed',
  CONFIRMING: 'Confirming',
  CONFIRMED: 'Confirmed',
  FAILED: 'Failed'
};